import { Grid2 } from "@mui/material";
import React, { useState } from "react";
import { TimeRangeStyles } from ".";

function TimeRange({ onRangeSelect }) {
  const [selectedRange, setSelectedRange] = useState("Month");

  const handleRangeSelect = (range) => {
    setSelectedRange(range);
    if (onRangeSelect) onRangeSelect(range); // Call the callback function
  };

  const rangeOptions = ["Day", "Week", "Month"];

  return (
    <Grid2>
      <Grid2 className={TimeRangeStyles.TimeRangeContainer}>
        <Grid2 className={TimeRangeStyles.FlexBox}>
          {rangeOptions.map((range) => (
            <Grid2
              key={range}
              className={`${TimeRangeStyles.selected} ${
                selectedRange === range ? TimeRangeStyles.Active : ""
              }`}
              onClick={() => handleRangeSelect(range)}
            >
              {range}
            </Grid2>
          ))}
        </Grid2>
        {/* <Grid2
          className={TimeRangeStyles.rangeText}
          onClick={() => handleRangeSelect("Custom")}
        >
          <Calendar className={TimeRangeStyles.Calendar} />
        </Grid2> */}
      </Grid2>
    </Grid2>
  );
}

export default TimeRange;
